/**
 * Parses a session datetime string as local time, handling both
 * timezone-aware and naive datetime strings
 */
const parseSessionDateTime = (sessionDateTime: string): Date => {
  // Check for timezone info: Z suffix, +offset, or -offset
  // Match patterns like: Z, +05:00, +0500, -05:00, -0500
  const hasTimezone =
    sessionDateTime.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(sessionDateTime);

  if (hasTimezone) {
    // Has timezone info - let native Date parser handle it
    return new Date(sessionDateTime);
  }

  // No timezone info - parse components and create as local time
  // Format: 2026-01-07T13:50:00
  const parts = sessionDateTime.match(
    /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/,
  );

  if (parts) {
    const [, year, month, day, hour, minute, second] = parts;
    // Note: month is 0-indexed in JavaScript Date constructor
    return new Date(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hour, 10),
      parseInt(minute, 10),
      parseInt(second, 10),
    );
  }

  // Fallback to default parsing if format doesn't match
  return new Date(sessionDateTime);
};

export default parseSessionDateTime;
